module.exports = __webpack_public_path__ + "media/images/train-icon-594dfcf2f3c7d02f968e3f721dffcd27.svg";